import script from "./Landing.vue?vue&type=script&setup=true&lang=js"
export * from "./Landing.vue?vue&type=script&setup=true&lang=js"

import "./Landing.vue?vue&type=style&index=0&id=5a9b9d97&scoped=true&lang=css"

import exportComponent from "D:\\_A-Project\\KoManga\\Ko-Manga-Center-Ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a9b9d97"]])

export default __exports__